import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { map } from 'rxjs';
import { BulkMessageNotificationType } from 'src/app/enum/account-type';
import { CategoryType } from 'src/app/enum/change-request-status-type';
import { BulkMessageService } from 'src/app/services/bulk-message.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { NotificationService } from 'src/app/services/notification-service';
import { UserdataService } from 'src/app/services/userdata.service';
import { environment } from 'src/environments/environment';
import { Editor, toHTML, Toolbar } from 'ngx-editor';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatTabChangeEvent } from '@angular/material/tabs';


@Component({
  selector: 'app-manage-push-notification-add',
  templateUrl: './manage-push-notification-add.component.html',
  styleUrls: ['./manage-push-notification-add.component.scss']
})
export class ManagePushNotificationAddComponent implements OnInit {




  displayedColumns: string[] = [
    'FirstName',
    'LastName',
    'Email',
    'MobileNumber',
    'ReferenceNumber',
  ];
  displayedColumns1: string[] = [
    'Action',
    'Name',
    'Email',
    'ContactNo',
    'CustomerNumber',
    'Address',

  ];
  data: any = []
  dataExcel: any = []
  dataSource: any = new MatTableDataSource(this.data);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  searchform: any;
  groupForm: any;
  applicationStatusList: any = [];
  applicationStatus: any;
  serviceProviderList: any = [];
  provinceList: any = [];
  isReset: boolean;
  complexApplicationList: any = [];
  filteredList1: any
  filteredList2: any
  filteredList3: any
  filteredList4: any;
  complexList: any;
  applicationList: any = [];
  BulkMessageNotificationTypeEnum = BulkMessageNotificationType
  userdetailsForm: any;
  groupMessageForm: any
  userDetailsList: any[];
  selectedUser: number;
  singleMessageForm: any
  requestBank: any;
  categoryTypeEnum = CategoryType
  templateList: any;
  isDisableServiceProvider = false
  isDisableCity = false
  selectedComplexList: any;
  serviceProviderUserDetailsList: any;
  complex: any[];
  cityList: { key: unknown; value: unknown; }[];
  selectedSeviceProviderUserList: any;
  searchText: any
  messageList: any;
  messageCount = 0
  showmessage = false
  showsub = false;
  // environment1=environment.RequestBankingDetails
  // environment:any=this.environment1
  environmentValue :any={}

  dropdownSettings: any = {}
  showSearch = true;
  selection: any[];
  selectedcustomers: any = {};
  selectedItems: Set<number> = new Set();
  showtemplate = false
  showmessagebox = false;
  selectedIndex: number;
  complexList1
  selectedRow: any;
  constructor(private fb: FormBuilder, private lookupDataService: LookupDataServiceService, private navigation: NavigationService,
    private cdr: ChangeDetectorRef, private toast: NotificationService, private bulkMessageService: BulkMessageService, private userDataService: UserdataService
  ) {
    this.environmentValue = environment

  }

  ngOnInit() {

    this.groupForm = this.fb.group({
      serviceProvider: [null],
      applicationStatus: [22],
      city: [null],
      complex: [null],
      cityText: []
    });
    this.init()
    this.getlookupData()


    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
      enableCheckAll: true,
      itemsShowLimit: 0,  
      selectionLimit: 1000, 
    };

  }
  init() {
    this.groupForm.get('cityText')?.disable();



    this.userdetailsForm = this.fb.group({
      fullName: [null],
      messagetrix: [null],
      mobileNumber: [null],
      email: [null],
      refrenceNumber: [null]
    })
    this.userdetailsForm.disable()
    this.groupMessageForm = this.fb.group({
      message: [null, Validators.required],
      subject: [null, Validators.required],
      messageNotificationType: ["1"],
      email: [null, Validators.required],
      categoryType: ["4"],
      template: [null]

    })
    this.singleMessageForm = this.fb.group({
      Recipent: [null, Validators.required],
      messageNotificationType: ["1"],
      message: ['', Validators.required],
      subject: [null, Validators.required]
    })
    this.searchform = this.fb.group({
      searchQuery: [null],
    })


  }

  onTabChange(event: MatTabChangeEvent) {
    this.selectedIndex = event.index;
    this.reset()

  }
  counttext() {
    if (this.singleMessageForm.value.message) {
      let value = this.singleMessageForm.value.message
      this.messageCount = value.length;
    }
    else {
      let value = this.groupMessageForm.value.message
      this.messageCount = value.length;
    }
  }
  // handleKeyDown(event: KeyboardEvent): void {
  //     if (event.key === 'Enter') {
  //         console.log(event);
  //         const delta = this.singleMessageForm.value.message // Get the Delta format

  //         // Convert Delta to HTML
  //         // const htmlContent = delta.getHTML(); 
  //         // console.log(htmlContent)
  //         return; // Just return and let the editor handle the line break
  //     }
  // }


  getlookupData() {
    this.lookupDataService.getApplicationStausType()
      .pipe(
        map(res => res ? [...res].filter((x: any) => x.key === 22) : [])
      )
      .subscribe(res => {
        this.applicationStatusList = res;
        this.filteredList2 = this.applicationStatusList.slice()
        if (res.length > 0) {
          this.applicationStatus = res[0].key;
        }
      });

    // Get service provider for all
    this.lookupDataService.getServiceProviderForAll()
      .pipe(
        map(res => res ? [...res].sort((a: any, b: any) => a.value.localeCompare(b.value)) : [])
      )
      .subscribe(res => {
        this.serviceProviderList = res;
        this.filteredList1 = this.serviceProviderList.slice()
      });

    // Get province list
    this.lookupDataService.getProvince()
      .pipe(
        map(res => res ? [...res].sort((a: any, b: any) => a.value.localeCompare(b.value)) : [])
      )
      .subscribe(res => {
        this.provinceList = res;
        this.filteredList3 = this.provinceList.slice()

        // Set a timeout and manually trigger change detection
        setTimeout(() => {
          this.isReset = false;
          this.cdr.detectChanges();
        }, 200);
      });

    // Get complex application list
    this.lookupDataService.getComplexApplication().subscribe(res => {
      if (res) {
        this.complexApplicationList = res;
        // this.filteredList4 = this.complexApplicationList.slice()
      }
    });
  }

  onChangeServiceProvider() {
    if (this.complexApplicationList.length > 0) {
      if (this.groupForm.value.serviceProvider) {
        this.complexList = [];
        this.isDisableCity = false;
        this.showmessagebox = false


        this.groupForm.get('complex').setValue(null)
        this.complexList = this.complexApplicationList
          .filter((item: any) => item.serviceProviderId === this.groupForm.value.serviceProvider)
          .map((item: any, index) => ({
            id: index,
            key: item.serviceProviderId,
            value: item.complexName
          }));

      }

      if (this.complexList.length > 0) {
        this.complexList = this.complexList
          .sort((a, b) => a.value.localeCompare(b.value));
        this.filteredList4 = [...this.complexList]
        this.complexList1=this.complexList
        console.log(this.complexList);


      }

      if (this.groupForm.value.serviceProvider) {
        if (this.groupForm.value.serviceProvider == -1) {

          this.isDisableCity = true;
          this.showSearch = false;
          this.showmessagebox = true
          //   this.city = undefined;
          this.complex = undefined;
          //   this.cityText = undefined;
          //   this.groupMessage.applicationList = [];

          const tempParams = {
            customerName: null,
            email: null,
            mobileNumber: null,
            customerReferenceNumber: null,
            address: null,
            serviceproviderId: -1
          };

          this.applicationList.push(tempParams);
        }
        else {
          this.isDisableCity = false;
          this.showSearch = true;
        }
      }
      else {
        //   this.isDisableCity = false;
        //   this.showSearch = true;
        this.applicationList = [];
      }
    }
  }
  selectedCount = 0;
updatePlaceholder() {
  this.selectedCount = this.groupForm.get('complex')?.value?.length || 0;
}
  getSelectedCount() {
    const selectedCount = this.groupForm.get('complex')?.value?.length || 0;
    return selectedCount > 0 ? `${selectedCount} selected` : 'Select The Complex';
  }
  oncitychange() {
    const selectedComplex = this.groupForm.value.complex;

    if (selectedComplex && selectedComplex.length > 0 ) { 
      this.groupForm.get('cityText')?.disable();
    } else {
      this.groupForm.get('cityText')?.enable();
    }
  }
  typecity(){
    console.log('hit');
    
    if(this.groupForm.value.cityText)
        this.complexList=[]

    else
    this.complexList=this.complexList1
}
  oncomplexchange() {
    const selectedComplex = this.groupForm.value.complex;
    console.log(selectedComplex);
    this.complex = [...selectedComplex]
    // Get the selected complex value
    if (selectedComplex && selectedComplex.length > 0) { // Check if something is selected
      this.groupForm.get('cityText')?.disable();
    } else if( this.groupForm.value.city) {
      this.groupForm.get('cityText')?.enable(); // Enable the cityText field
    }
  }

  goToBack() {
    this.navigation.gotomanagepushnotification();
  }
  reset() {
    this.init()
    this.isDisableServiceProvider = false
    this.groupForm.reset()
    this.groupForm.get('applicationStatus').setValue(22)
    this.data = [];
    this.dataSource = new MatTableDataSource(this.data);
    this.showmessagebox = false
    this.showmessage = false;
    this.messageCount = 0
    this.complex=null
    this.complexList=null;
  }


  singleMessageSend(): void {
    let message: any = {}
    message.fullName = this.userdetailsForm.value.fullName;
    message.requestBank = this.showmessage
    message.email = this.userdetailsForm.value.email;
    message = { ...message, ...this.singleMessageForm.value };
    message.messageNotificationType = parseInt(this.singleMessageForm.value.messageNotificationType)
    message.message += '-Home Connect System';

    if (!message.subject) {
      this.toast.showError('Please enter subject')
      return;
    }

    // Validate message content
    if (!message.message) {
      this.toast.showError('Please enter message content')
      return;
    }

    this.bulkMessageService.pushsingleMessage(message).subscribe(res => {
      if (res === this.environmentValue.RequestBankingDetails.SingleMessageSent) {
        this.toast.showSuccess('Message sent successfully');
        this.userdetailsForm.reset(); 
        this.reset(); 
        this.goToBack(); 
      }

      if (res === this.environmentValue.RequestBankingDetails) {
        this.toast.showSuccess('Banking detail update request sent successfully.');
        this.userdetailsForm.reset();
        this.reset();
        this.goToBack();
      }
    });
  }

  async groupMessageSend(): Promise<boolean> {
    console.log(this.groupMessageForm.value);


    // Validate subjectl

    if (!this.groupMessageForm.value.subject) {
      this.toast.showError("Please enter subject");
      return false;
    }



    // Validate message content
    if (!this.groupMessageForm.value.message) {
      this.toast.showError("Please enter message content");
      return false;
    }


    try {
      let groupmessage: any = {
        categoryType: parseInt(this.groupMessageForm.value.categoryType),
        message: this.groupMessageForm.value.message,
        messageNotificationType: parseInt(this.groupMessageForm.value.messageNotificationType),
        subject: this.groupMessageForm.value.subject,
        messagetrix: '',
      }
        if (this.groupForm.value.serviceProvider == -1)
                groupmessage.applicationList = [ ...this.applicationList ]
            else
                groupmessage.applicationList = [ ...this.data.filter((item) => this.selectedItems.has(item.id)) ]

      console.log(groupmessage);

      // Send the bulk message
      await this.bulkMessageService.pushbulkMessage(groupmessage).subscribe((res) => {

        // Handle response
        if (res === this.environmentValue.RequestBankingDetails.BulkMessagesSent) {
          this.toast.showSuccess("Message sent successfully");
          this.goToBack();
        } else if (res === this.environmentValue.RequestBankingDetails.CannotFindServiceProviderUserList) {
          this.toast.showError("The message cannot be sent. User not found.");
          this.goToBack();
        }
      });


    }
    catch (error) {
      this.toast.showError("Error sending group message:", error);
      return false;
    }

    return true;
  }

  async searchUser(): Promise<boolean> {

    this.selectedUser = 0;
    let searchText = this.searchform.value.searchQuery;
    if (searchText) {
      this.userdetailsForm.reset()

      try {
        await this.userDataService.getUserDetails(searchText).subscribe((res) => {

          if (res) {
            this.userDetailsList = [...res];
            this.dataSource = new MatTableDataSource(this.userDetailsList)
            if (this.userDetailsList.length === 1) {
              this.selectedUser = 1;
              this.selectedUserClick(this.userDetailsList[0]);
              return true;
            }

            return true;
          } else {
            this.toast.showError("Nothing Found!");
            return false;
          }
        });

      } catch (error) {
        this.toast.showError("Error fetching user details:", error);
        return false;
      }
    } else {
      this.toast.showError("Enter Search Value");
      return false;
    }

    return true;
  }

  selectedUserClick(user: any): void {
    if (user) {
      this.selectedRow=user
      this.userdetailsForm.patchValue(user)
      this.singleMessageForm.get('Recipent').setValue(user.mobileNumber);
      this.showmessagebox = true;
    }
  }

  requestBankChange(index) {
    if (index.checked) {
      this.showmessage = true;
    }
    else
      this.showmessage = false;
  }

  categoryType() {
    this.groupMessageForm.patchValue({ message: '' })
    let categoryType = parseInt(this.groupMessageForm.value.categoryType)
    if (categoryType != this.categoryTypeEnum.New) {
      this.lookupDataService.getTemplateList(this.groupMessageForm.value.categoryType, this.groupMessageForm.value.messageNotificationType).subscribe((result) => {
        if (result) {
          this.templateList = result;
          this.showtemplate = true
        }
      });
    }
    else {
      this.showtemplate = false
      this.groupMessageForm.get('message').setValue('')
    }
  }

  selectTemplate() {
    if (this.groupMessageForm.value.template) {
      this.bulkMessageService.getTemplateContent(this.groupMessageForm.value.template).subscribe((res) => {
        if (res.result) {
          this.groupMessageForm.patchValue({ message: res.result.content })
        }
      });
    }
  }

  Onchange(): void {
    if (!this.isReset) {
      const postdata: any = {};
      console.log(this.groupForm.value);
      if (this.groupForm.value.serviceProvider) {
        if (!this.isDisableServiceProvider && !this.isDisableCity) {
          this.isDisableServiceProvider = true;
        }
        postdata.serviceProviderId = this.groupForm.value.serviceProvider;
      }

      if (this.groupForm.value.city) {
        if (!this.isDisableServiceProvider && !this.isDisableCity) {
          this.isDisableCity = true;
        }
        postdata.city = this.groupForm.value.city;
      }

      if (this.applicationStatus) {
        postdata.applicationStatus = this.applicationStatus;
      }

      if (this.groupForm.value.cityText) {
        this.complex = [];
        postdata.cityText = this.groupForm.value.cityText;
      }

      if (this.complex && this.complex.length > 0) {
        this.groupForm.patchValue({ cityText: '' })
        this.selectedComplexList = [];
        this.complexList.forEach((item1: any) => {
          this.complex.forEach((item2: any) => {
            if (item1.id === item2.id) {
              this.selectedComplexList.push(item1.value);
            }
          });
        });
        postdata.complex = this.selectedComplexList;
      }

      this.bulkMessageService.getMessagingUserDetailsBySPIdandCity(postdata).subscribe((result: any) => {
        if (result && result.length > 0) {
          this.serviceProviderUserDetailsList = result; // Replaces angular.copy
          this.data = result.map((item, index) => ({
            ...item,
            id: index + 1 // You can change this logic as needed
          }));
          this.dataSource = new MatTableDataSource(this.data)
          this.selection = new Array(this.serviceProviderUserDetailsList.length).fill(false);

          this.dataSource.paginator = this.paginator;
          console.log(this.data);


          if (!this.groupForm.value.city) {
            let tempCityList = Array.from(new Set(result.map((x: any) => x.city)));
            this.cityList = tempCityList.map(val => ({ key: val, value: val }));
            this.cityList.sort((a: any, b: any) => a.value.localeCompare(b.value));
          }

          if (!this.groupForm.value.serviceProvider) {
            let tempServiceProviderIdList = Array.from(new Set(result.map((x: any) => x.serviceProviderId)));
            const tempServiceProviderList = [...this.serviceProviderList];

            this.serviceProviderList = tempServiceProviderList.filter((val: any) =>
              tempServiceProviderIdList.includes(val.key)
            );
          }
        }
        else{
          debugger
          this.dataSource= new MatTableDataSource(result)
          this.dataSource.paginator = this.paginator;
      }
      });
    }

  }


  toggleAllCheckboxes(event: MatCheckboxChange) {
    const checked = event.checked;
    this.data.forEach((item) => {
      if (checked) {
        this.selectedItems.add(item.id);
      } else {
        this.selectedItems.delete(item.id);
      }
    });
  }

  onCheckboxChange(item: any) {
    if (this.selectedItems.has(item.id)) {
      this.selectedItems.delete(item.id);
    } else {
      this.selectedItems.add(item.id);
    }
    this.showmessagebox = this.selectedItems.size > 0;
  }

  isSelected(item: any): boolean {
    return this.selectedItems.has(item.id);
  }
}
